import './App.css';
import useScrollListener from './hooks/useScrollListener';
import { RouterProvider, useLocation } from 'react-router-dom';
import LogInPromptPopUp from './components/pages/LogIn/LogInPromptPopUp';
import router from './Routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import GradientLogo from '../public/icons/GradientLogo';
import AppInitializer from './components/auth/AppInitializer';

// QueryClient setup
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 1000 * 60 * 5,
      // cacheTime: 1000 * 60 * 30,
      // retry: 1,
      // refetchOnWindowFocus: false,
      // keepPreviousData: true,
    },
  },
});

// Error fallback component
function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div role='alert'>
      <h2>Something went wrong:</h2>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

function App() {
  const scroll = useScrollListener();
  // const location = useLocation();

  // Handle route changes
  // useEffect(() => {
  // Optional: Reset or invalidate queries on route change
  // queryClient.resetQueries(['posts']);
  // queryClient.invalidateQueries(['posts']);
  // }, [location.pathname]);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        console.error('Error caught by boundary:', error, info);
      }}
      onReset={() => {
        // Reset any necessary state here
        queryClient.clear();
      }}>
      <AppInitializer>
        <QueryClientProvider client={queryClient}>
          <Toaster position='bottom-right'
            // theme='dark'
          />
          <LogInPromptPopUp />
          {/* <Suspense fallback={<div className='splash-logo-wrapper'><GradientLogo svgClass={'splash-logo'}/></div>}> */}
          <RouterProvider router={router} />
          {/* </Suspense> */}
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </AppInitializer>
    </ErrorBoundary>
  );
}

export default App;
